import getUrl from 'lib/url'
import React, { useEffect, useState } from 'react'

interface ICommunity {
  info: {
    series_name: string
    series_id: number
    motor_id: number
    motor_name: string
  }
  type: number
}

export default function RecommendCommunities({
  handleClickItem,
}: {
  handleClickItem: (id: number, name: string) => void
}) {
  const [list, setList] = useState<ICommunity[]>([])
  useEffect(() => {
    fetch(
      getUrl(
        '/motor/community/get_community_by_offset?offset=0&count=10&tab_name=recommend'
      )
    )
      .then(res => res.json())
      .then(json => {
        setList(json.data?.list || [])
      })
  }, [])

  return (
    <ul className="list">
      {list.map((item, index) => {
        const community = item.info
        return (
          <li className="item" key={index}>
            <a
              href={`/community/${community?.series_id}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                handleClickItem(item.info?.motor_id, item.info?.motor_name)
              }}
            >
              {community?.series_name}车友圈
            </a>
          </li>
        )
      })}
      <style jsx>
        {`
          .list {
            display: flex;
            flex-wrap: wrap;
            width: 380px;
          }
          .item {
            background-color: white;
            flex: 0 0 auto;
            height: 32px;
            margin-bottom: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #1f2129;
            font-size: 14px;
            padding: 6px 16px;
            border-radius: 2px;
            margin-right: 8px;
            cursor: pointer;
          }
        `}
      </style>
    </ul>
  )
}
